// Pre-init defense: catch any non-configurable property redefine attempts (e.g. Wix / Zone.js)
(function () {
  if (typeof window === 'undefined' || typeof Object.defineProperty !== 'function') return;
  var origDefineProperty = Object.defineProperty;
  try {
    Object.defineProperty = function (obj, prop, descriptor) {
      try {
        return origDefineProperty.call(Object, obj, prop, descriptor);
      } catch (err) {
        if (err && (
          String(err).indexOf('Cannot redefine property') !== -1 ||
          String(err).indexOf('redefine') !== -1
        )) {
          try {
            if (descriptor && 'value' in descriptor) {
              obj[prop] = descriptor.value;
            }
          } catch (_) { }
          return obj;
        }
        throw err;
      }
    };
  } catch (_) { }
})();
